import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

export const SettingsLayout = lazy(() => import('../components/Settings'));
const Preferences = lazy(() => import('../components/Preferences/Preferences'));

const settingsRoute: RouteObject = {
  path: 'settings',
  children: [
    { index: true, element: <Navigate to='/settings/preferences' replace /> },
    { path: 'modules', element: <Navigate to='/settings/preferences' replace /> },
    { path: 'preferences', element: <Preferences /> },
  ],
};

export default settingsRoute;
